export const classNames = (
  ...classes: (string | undefined | boolean | null)[]
): string => classes.filter(Boolean).join(' ');
